import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { motion, useReducedMotion } from "framer-motion";
import { Header } from "./Header";
import { Footer } from "./Footer";

export const Layout = ({ children }) => {
  const { pathname } = useLocation();
  const reduce = useReducedMotion();
  const rest = pathname.split("/").slice(2).join("/");
  const prevRest = useRef(rest);

  useEffect(() => {
    if (prevRest.current !== rest) {
      window.scrollTo({ top: 0, behavior: "instant" });
      prevRest.current = rest;
    }
  }, [rest]);

  return (
    <div className="min-h-screen bg-[#F7F8F5]">
      <Header />
      <motion.main
        key={rest}
        initial={reduce ? { opacity: 1 } : { opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
      >
        {children}
      </motion.main>
      <Footer />
    </div>
  );
};
